import { render, staticRenderFns } from "./PrimaryHeading.vue?vue&type=template&id=21443ab8&"
import script from "./PrimaryHeading.vue?vue&type=script&lang=js&"
export * from "./PrimaryHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports